// Transport for NSW passenger route timetables, keyed by Busable operatorId.
//
// routeUrl is the stable TfNSW route detail page and is the primary link.
//
// PDF URLs are deliberately NOT stored here. TfNSW stamps each timetable with
// its publication date and returns 403 on superseded URLs, so any hardcoded
// link rots at the next republish. timetablePdfPath() instead points at the
// Busable API's /timetable/tfnsw/* resolver, which reads the current href off
// the route page at request time (v5 busable-workspace, marketplace/api).
//
// Regions absent from this map (ogdens_western, ogdens_condobolin) have no TfNSW
// passenger routes -- only school services -- and keep the Busable widget on the
// Passenger Timetables tab.

const TFNSW_ROUTE = "https://transportnsw.info/routes/details/ogdens-coaches";
const TIMETABLE_RESOLVER = "https://api.busable.app/timetable/tfnsw";

const PASSENGER_TIMETABLES = {
    ogdens_orana: {
        intro:
            "You can access Ogden's Coaches' Orana routes 555 and 556 below. Each route links " +
            "to the Transport for NSW timetable, which is kept up to date.",
        routes: [
            {
                number: "555",
                name: "Narromine to Dubbo via Mitchell Hwy",
                routeUrl: `${TFNSW_ROUTE}/555/51555`,
            },
            {
                number: "556",
                name: "Wellington to Dubbo via Geurie and Wongarbon",
                routeUrl: `${TFNSW_ROUTE}/556/51556`,
            },
        ],
    },
    ogdens_mudgee: {
        intro:
            "You can access Ogden's Coaches' Mudgee loop services 560, 561, 562 and 563 below. " +
            "Each route links to the Transport for NSW timetable, which is kept up to date.",
        routes: [
            { number: "560", name: "Mudgee East (Loop Service)", routeUrl: `${TFNSW_ROUTE}/560/71560` },
            { number: "561", name: "Mudgee West (Loop Service)", routeUrl: `${TFNSW_ROUTE}/561/71561` },
            { number: "562", name: "Mudgee South (Loop Service)", routeUrl: `${TFNSW_ROUTE}/562/71562` },
            { number: "563", name: "Mudgee North (Loop Service)", routeUrl: `${TFNSW_ROUTE}/563/71563` },
        ],
    },
};

// Maps a TfNSW route page to our resolver, which 302s to the current PDF.
const ROUTE_PATH = /\/routes\/details\/([A-Za-z0-9-]+\/[A-Za-z0-9-]+\/[A-Za-z0-9-]+)$/;

export const timetablePdfPath = (routeUrl) => {
    const match = (routeUrl || "").match(ROUTE_PATH);
    return match ? `${TIMETABLE_RESOLVER}/${match[1]}` : null;
};

export const getPassengerTimetables = (operatorId) => PASSENGER_TIMETABLES[operatorId] || null;

export const hasPassengerTimetables = (operatorId) =>
    Boolean(PASSENGER_TIMETABLES[operatorId]?.routes?.length);

export default PASSENGER_TIMETABLES;
